import { BarLabelProps } from "@mui/x-charts";

import { getUnitValueLabel, getUnitValueText } from "~/utils/unitUsageHelpers";
import { TotalUsageType } from "./DashboardPPTCharts";

const TotalUsageBarLabel = ({
  unitLabel = "",
  totalUsage,
  ...props
}: BarLabelProps & { unitLabel: string; totalUsage: TotalUsageType }) => {
  const isZeroUsage = totalUsage?.unitUsagePercentage === 0;
  const fullWidth = isZeroUsage ? props.width : Math.max(props.width, props.width / (totalUsage?.unitUsagePercentage / 100));

  if (!totalUsage || Number.isNaN(fullWidth) || (props.seriesId === "adjustedUnitTotal" && !isZeroUsage)) {
    return null;
  }

  const context = document.createElement("canvas").getContext("2d");
  if (context) {
    context.font = getComputedStyle(document.body).font;
  } else {
    return null;
  }

  const allocatedUnits = totalUsage.allocatedUnits ?? 0;
  const usedUnitsText = getUnitValueText(totalUsage.usedUnits, unitLabel);
  const allocatedUnitsText = `of ${getUnitValueLabel(allocatedUnits, unitLabel)}`;
  let textContent: any = `${usedUnitsText} ${allocatedUnitsText}`;

  let textWidth: number | number[] = context.measureText(`${textContent}`).width ?? -8;
  if (textWidth + 8 > fullWidth) {
    textWidth = [context.measureText(`${usedUnitsText}`).width ?? -8, context.measureText(`${allocatedUnitsText}`).width ?? -8];

    const maxWidth = Math.max(...textWidth);
    if (maxWidth + 8 > fullWidth) {
      return null;
    }

    textContent = (
      <>
        <tspan dx={0} dy="-0.5em">
          {usedUnitsText}
        </tspan>
        <tspan dx={textWidth[1] * -1 + (textWidth[1] - textWidth[0]) / 2 - 2} dy="1em">
          {allocatedUnitsText}
        </tspan>
      </>
    );
  }

  const textMetrics = context.measureText(`${textContent}`);
  const textHeight = Math.abs(textMetrics.actualBoundingBoxAscent) + Math.abs(textMetrics.actualBoundingBoxDescent);

  if (textHeight * (Array.isArray(textWidth) ? 2 : 1) + 4 > props.height) {
    return null;
  }

  return (
    <text className={props.className} x={props.x + fullWidth / 2} y={props.y + props.height / 2}>
      {textContent}
    </text>
  );
};

export default TotalUsageBarLabel;
